const zh = {
    error1: '服务器错误, 请重试',
    error1_1: '服务器内部错误，请稍后再试',
    error1_2: '服务器不支持该请求，请稍后再试',
    error1_3: '服务器不可用，请稍后再试',
    error1_4: '服务器网关超时，请稍后再试',
    error1_5: '服务器不支持HTTP版本，请稍后再试',
    error2: '需要传入请求数据',
    error3: '参数错误',
    error4: '数据库未初始化',
    error5: '枚举类型错误',
    error6: '传参错误',
    error7: '缺少token或token已过期',
    error8: 'preUpload.Id不存在',
    error9: 'fileInfo.Id不存在',
    error10: '文件索引已存在',
    error11: '文件缺失part',
    error12: '未找到对应文件',
    error13: 'Admin的权限不允许修改',
    error14: '刷新token不存在',
    error15: '未找到对应数据',
    error16: '未找到手机号',
    error17: '该手机号已存在',
    error18: '账号或密码错误',
    error19: '多个员工不存在',
    error20: '未找到该组织',
    error21: '组织已存在该员工',
    error22: '组织正在盘点',
    error23: '日志本不存在',
    error24: 'doc不存在',
    error25: '商品种类不存在',
    error26: '商品不存在',
    error27: '扫描不存在',
    error28: '多个扫描不存在',
    error29: '该条码已存在至该扫描中',
    error30: '没有找到该出库单/入库单数据',
    error31: '库存不足',
    error32: '没有找到该盘点单',
    error33: '盘点项不存在',
    error34: '编码已存在，不得重复添加！',
    error35: '网络错误，请检查你的网络连接后重试。',
    error36: '请求超时，请重试。',
    error37: '商品类目编码重复。',
    error38: '扫描单中无商品数据和条形码数据导致无法出/入库，即将关闭页面。',
    error39: '库存不足',
    error40: '超领申请不存在',
    error41: '申请状态不允许此操作',
    error42: '需求明细无效或不匹配',
    error43: '超领数量必须大于0',
    error44: '超领明细已生成出库单',
    error45: '终端客户编码已存在',
    error46: '收货地址不存在',
    error47: '收货方名称已存在',
    error48: '设备不存在',
    error49: '当前设备状态不允许此操作',
    error50: '设备不在库，无法领用',
    error51: '设备不在用，无法归还',
    error52: '设备已有未归还的领用记录',
    error53: '该记录类型必须使用专用接口',
    error54: '设备已报废',
    error55: '非法的设备状态迁移',
    error56: '保养配置无效',
    error57: '资产编号已存在',
    error58: '设备记录不存在',
    error59: '设备类目编号已存在',
    error60: '设备类目不存在',
    error61: '父类目未启用，无法启用子类目',
    error62: '类目下存在子类目，无法删除',
    error63: '类目已被使用，无法修改编号或名称',
    error64: '保管部门为必填项',
    error65: '设备只能关联叶子类目',
    error66: '操作执行排队中，请稍后再试',
};

export default zh;
